module.exports = __webpack_public_path__ + "img/bg2.53e01edb.png";